export const athandAudioEffects: Map<string, string> = new Map<string, string>([]);
